import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, Typography, } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { FooterLayout } from "./FooterLayout.js";
import { isCurrentOrigin, S4Logo, SISLogo, SSFLogo, useEnv, } from "./index.js";
import { CederquistLogo } from "./logo/CederquistLogo.js";
export const Footer = () => {
    const env = useEnv();
    const { t } = useTranslation("Footer");
    return (_jsxs(FooterLayout, { logos: _jsx(FooterLogos, {}), children: [showSsfLogoAboveAddress(env) ? (_jsx(SchackSeLink, { sx: { maxWidth: "275px", marginLeft: "-20px" }, children: _jsx(SSFLogo, {}) })) : (_jsx("div", { children: _jsx(Trans, { t: t, i18nKey: "address" }) })), !!t("visitingAddress") && _jsx("div", { children: t("visitingAddress") }), !!t("email") && (_jsx("div", { children: _jsx("a", { href: `mailto:${t("email")}`, children: t("email") }) })), !!t("phone") && (_jsx("div", { children: _jsx("a", { href: `tel:${t("phone")}`, children: t("phone") }) }))] }));
};
const showSsfLogoAboveAddress = (env) => !isCurrentOrigin(env.VITE_S4_WEB_URL) &&
    !isCurrentOrigin(env.VITE_REG_WEB_URL);
const FooterLogos = () => {
    const { t } = useTranslation("Footer");
    const env = useEnv();
    if (isCurrentOrigin(env.VITE_S4_WEB_URL)) {
        return (_jsxs("div", { children: [_jsx("a", { href: "https://schack.se/schackfyran/", children: _jsx(S4Logo, {}) }), _jsx(FooterDivider, {}), _jsx(SchackSeLink, { children: _jsx(SSFLogo, {}) })] }));
    }
    if (isCurrentOrigin(env.VITE_REG_WEB_URL)) {
        return (_jsx(SchackSeLink, { children: _jsx(SSFLogo, {}) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("a", { href: "https://schack.se/schack-i-skolan/", children: _jsx(SISLogo, {}) }), _jsx(FooterDivider, {}), _jsx(Typography, { variant: "caption", sx: { display: "block", textAlign: "right" }, children: t("sponsor") }), _jsx(Box, { component: "a", href: "https://www.cederquist.se", sx: { svg: { maxWidth: ({ spacing }) => spacing(28) } }, children: _jsx(CederquistLogo, {}) })] }));
};
const FooterDivider = ({ sx }) => (_jsx(Divider, { sx: {
        opacity: 0.75,
        my: 1,
        mx: -1,
        borderColor: "rgba(255, 255, 255, .12)",
        ...sx,
    } }));
const SchackSeLink = ({ children, sx, }) => (_jsx(Box, { component: "a", href: "https://schack.se", sx: {
        display: "block",
        svg: {
            display: "block",
        },
        ...sx,
    }, children: children }));
//# sourceMappingURL=Footer.js.map